import DOMPurify from "dompurify";

// Modelos cadastrados antes do editor rico são texto puro, com quebras de linha.
const ehHtml = (texto) => /<\/?[a-z][\s\S]*>/i.test(texto || "");

const escapaHtml = (texto) =>
  texto
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

/**
 * Converte o texto do modelo para o HTML aceito pelo editor. Texto puro vira um parágrafo
 * por linha — carregado direto, o Quill juntaria todas as linhas em uma só.
 */
export const textoCertidaoParaEditor = (texto) => {
  if (!texto) return "";
  if (ehHtml(texto)) return texto;

  return texto
    .split(/\r?\n/)
    .map((linha) => "<p>" + (linha.length > 0 ? escapaHtml(linha) : "<br>") + "</p>")
    .join("");
};

/**
 * Editor vazio devolve "<p><br></p>"; grava vazio para a API continuar tratando como
 * modelo sem texto.
 */
export const textoCertidaoParaGravar = (html) => {
  const somenteTexto = (html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
  return somenteTexto.length > 0 ? html : "";
};

const contaOcorrencias = (texto, trecho) => texto.split(trecho).length - 1;

/**
 * Variáveis que aparecem no texto visível mas não inteiras no HTML — formatação aplicada
 * em só parte do placeholder (ex.: `{{<strong>CNPJ</strong>}}`) impede a substituição
 * na API e o placeholder sairia cru na certidão.
 */
export const variaveisQuebradas = (html, variaveis) => {
  const texto = (html || "").replace(/<[^>]*>/g, "");

  return (variaveis || []).filter(
    (v) => contaOcorrencias(texto, v.placeholder) > contaOcorrencias(html || "", v.placeholder)
  );
};

/**
 * HTML sanitizado da certidão para dangerouslySetInnerHTML. Certidão emitida antes do
 * editor rico é texto puro e precisa manter as quebras de linha (ver `preservaQuebras`).
 */
export const htmlCertidao = (texto) => ({
  __html: DOMPurify.sanitize(texto || "", { USE_PROFILES: { html: true } }),
});

export const preservaQuebras = (texto) => !ehHtml(texto);
